'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrialProduct = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _bound = require('redux/saga/entities/bound');

var _MsaOfferProduct2 = require('./MsaOfferProduct');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrialProduct = exports.TrialProduct = function (_MsaOfferProduct) {
  (0, _inherits3.default)(TrialProduct, _MsaOfferProduct);

  function TrialProduct() {
    (0, _classCallCheck3.default)(this, TrialProduct);
    return (0, _possibleConstructorReturn3.default)(this, (TrialProduct.__proto__ || (0, _getPrototypeOf2.default)(TrialProduct)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrialProduct, null, [{
    key: 'loadCreditStat',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadCreditStat(client, msa) {
      return _regenerator2.default.wrap(function loadCreditStat$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msaCreditStatById, [client, msa.id]);

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);
              _context.next = 9;
              return (0, _effects.call)(logger.warn, 'Failed to find credit stat for msa [' + msa.id + ']', _context.t0);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, loadCreditStat, this, [[0, 5]]);
    })
  }, {
    key: 'loadPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadPurchaseData(client) {
      var _ref, msaOfferId, msaOffer, msa;

      return _regenerator2.default.wrap(function loadPurchaseData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _effects.call)(TrialProduct.getProductData);

            case 2:
              _ref = _context2.sent;
              msaOfferId = _ref.msaOfferId;
              _context2.next = 6;
              return (0, _effects.call)(TrialProduct.loadOffer, client, msaOfferId);

            case 6:
              msaOffer = _context2.sent;

              if (!msaOffer) {
                _context2.next = 11;
                break;
              }

              msa = msaOffer.msa;
              _context2.next = 11;
              return (0, _effects.all)([(0, _effects.call)(TrialProduct.loadCreditStat, client, msa), (0, _effects.call)((0, _get3.default)(TrialProduct.__proto__ || (0, _getPrototypeOf2.default)(TrialProduct), 'loadPurchaseData', this), client)]);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }]);
  return TrialProduct;
}(_MsaOfferProduct2.MsaOfferProduct);

TrialProduct.key = 'TrialProduct';